import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/food_noimage.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-3f4475c2")

_pushScopeId("data-v-3f4475c2")
const _hoisted_1 = { class: "common-recipe-foodid-item" }
const _hoisted_2 = {
  key: 1,
  class: "common-recipe-foodid-item-icon",
  src: _imports_0
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.icon)
      ? (_openBlock(), _createBlock("img", {
          key: 0,
          class: "common-recipe-foodid-item-icon",
          src: _ctx.icon,
          onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
        }, null, 40, ["src"]))
      : (_openBlock(), _createBlock("img", _hoisted_2))
  ]))
})